import { render, staticRenderFns } from "./comStep3.vue?vue&type=template&id=2c608ac0&scoped=true&"
import script from "./comStep3.vue?vue&type=script&lang=js&"
export * from "./comStep3.vue?vue&type=script&lang=js&"
import style0 from "./comStep3.vue?vue&type=style&index=0&id=2c608ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c608ac0",
  null
  
)

export default component.exports